import { createSelector } from 'reselect'
import featureScopesSelector from './feature-scope/featureScopesSelector'

const e3dHideHangupButtonSelector = createSelector(
    featureScopesSelector,
    (featureScopes): boolean => featureScopes.includes('e3dHideHangupButton'),
)

export default e3dHideHangupButtonSelector
